import React from "react";
import DPCard from "Components/DP/DPCard/DPCard";
import useStyles from "./styles";
import Skeleton from "@material-ui/lab/Skeleton";
import { Grid } from "@material-ui/core";

const SkeletonMetricBox = () => {
  const classes = useStyles();

  return (
    <DPCard classOverrides={classes.card}>
      <Grid container direction={"column"} spacing={2}>
        <Grid item>
          <Skeleton variant={"text"} height={20} />
        </Grid>
        <Grid item>
          <Skeleton variant={"rect"} width={"80%"} height={50} />
        </Grid>
        <Grid item>
          <Skeleton variant={"text"} height={20} />
        </Grid>
      </Grid>
    </DPCard>
  );
};

export default SkeletonMetricBox;
